import React, { useState, useEffect } from 'react';
import { housesAPI } from '../services/api';
import './ConnectionStatus.css';

const ConnectionStatus = () => {
  const [isConnected, setIsConnected] = useState(true);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    checkConnection();
    // Check connection every 60 seconds (reduced frequency to avoid excessive API calls)
    const interval = setInterval(checkConnection, 60000);
    return () => clearInterval(interval);
  }, []);

  const checkConnection = async () => {
    setChecking(true);
    try {
      // Use health endpoint instead of getAll to reduce load
      await fetch('/api/health');
      setIsConnected(true);
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || 
          error.message === 'Network Error' || 
          error.code === 'ERR_SSL_PROTOCOL_ERROR' ||
          error.message?.includes('SSL') ||
          error.message?.includes('protocol')) {
        setIsConnected(false);
      } else {
        // Other errors might mean backend is up but has issues
        setIsConnected(true);
      }
    } finally {
      setChecking(false);
    }
  };

  if (isConnected) {
    return null;
  }

  return (
    <div className="connection-status error">
      <div className="connection-message">
        <strong>⚠️ Backend Connection Error</strong>
        <p>Unable to connect to the backend server at http://localhost:8000</p>
        <p>Please ensure:</p>
        <ul>
          <li>The backend server is running</li>
          <li>Docker containers are up: <code>docker-compose up</code></li>
          <li>The backend is accessible at http://localhost:8000</li>
        </ul>
        <button onClick={checkConnection} disabled={checking} className="retry-button">
          {checking ? 'Checking...' : 'Retry Connection'}
        </button>
      </div>
    </div>
  );
};

export default ConnectionStatus;


